import React, { useMemo } from 'react';
import { StaticSelect } from '@kineticdata/react';
import { Map } from 'immutable';
import { FieldWrapper } from './FieldWrapper';
import {
  Status,
  SuggestionsContainer,
  generateInput,
  generateSingleSelectionsContainer,
  generateSingleSelection,
} from './TypeaheadDefaults';
import classNames from 'classnames';
import { parseRenderOptions } from './utils';

const selectionToValue = selection =>
  selection.get('displayValue') ||
  selection.get('label') ||
  selection.get('value');

const Suggestion = ({ suggestion, active, custom }) => (
  <div className={classNames('suggestion', { active })}>
    {custom && <div className="small">Custom Option</div>}
    <div className="large">
      {suggestion.get('label') || suggestion.get('value')}
    </div>
    {suggestion.get('detail') && (
      <div className="small">{suggestion.get('detail')}</div>
    )}
  </div>
);
export const TypeaheadInput = ({ componentOptions = {}, ...props }) => {
  const components = useMemo(
    () => ({
      Input: generateInput({
        size: componentOptions.size,
        className: componentOptions.fieldClassName,
      }),
      Selection: generateSingleSelection(selectionToValue, {
        size: componentOptions.size,
      }),
      SelectionsContainer: generateSingleSelectionsContainer({
        size: componentOptions.size,
      }),
    }),
    [componentOptions.size, componentOptions.fieldClassName],
  );
  return (
    <StaticSelect
      allowNew={props.allowNew}
      components={{
        ...components,
        Status,
        Suggestion,
        SuggestionsContainer,
      }}
      disabled={props.disabled}
      id={props.id}
      value={
        props.value
          ? props.options.find(
              option =>
                option.get('value') === props.value ||
                option.get('label') === props.value,
            ) || Map({ label: props.value, value: props.value })
          : null
      }
      onChange={option => props.onChange(option ? option.get('value') : '')}
      onBlur={props.onBlur}
      onFocus={props.onFocus}
      options={props.options}
      placeholder={props.placeholder}
      form={props.form}
      invalid={props.invalid}
    />
  );
};

export const SelectTypeaheadField = props => {
  const renderOptions = parseRenderOptions(props);
  return (
    <FieldWrapper {...props} renderOptions={renderOptions}>
      <TypeaheadInput
        componentOptions={{
          size: renderOptions.size,
          fieldClassName: renderOptions.fieldClassName,
        }}
        id={props.id}
        value={props.value}
        onBlur={props.onBlur}
        onChange={props.onChange}
        onFocus={props.onFocus}
        options={props.options}
        placeholder={props.placeholder}
        disabled={!props.enabled}
        form={props.form}
        invalid={renderOptions.hasErrors}
      />
    </FieldWrapper>
  );
};

export const TextTypeaheadField = props => {
  const renderOptions = parseRenderOptions(props);
  return (
    <FieldWrapper {...props} renderOptions={renderOptions}>
      <TypeaheadInput
        componentOptions={{
          size: renderOptions.size,
          fieldClassName: renderOptions.fieldClassName,
        }}
        allowNew
        id={props.id}
        value={props.value}
        onBlur={props.onBlur}
        onChange={props.onChange}
        onFocus={props.onFocus}
        options={props.options}
        placeholder={props.placeholder}
        disabled={!props.enabled}
        form={props.form}
        invalid={renderOptions.hasErrors}
      />
    </FieldWrapper>
  );
};
